import { Box, Divider, Heading, List, ListItem, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../LoadingSpinner";

const GptecFAQ = () => {
  const [faqData, setFaqData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetch(`api/getBlob?blob=FAQ.txt&container=winter`)
      .then((response) => response.text())
      .then((data) => {
        setFaqData(data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Box maxW="6xl" mx="auto" p={6}>
      {faqData?.split("---").map((section, index) => (
        <Box key={index} mb={8}>
          {section.split("\n").map((line, lineIndex) => {
            if (line.startsWith("## ")) {
              return (
                <Heading key={lineIndex} as="h2" size="xl" mt={4} mb={2}>
                  {line.replace("## ", "")}
                </Heading>
              );
            }
            if (line.startsWith("### ")) {
              return (
                <Heading key={lineIndex} as="h3" size="lg" mt={3} mb={2}>
                  {line.replace("### ", "")}
                </Heading>
              );
            }
            if (line.startsWith("- ")) {
              return (
                <List key={lineIndex} spacing={2} pl={4} styleType="disc">
                  <ListItem>{line.replace("- ", "")}</ListItem>
                </List>
              );
            }
            if (line.startsWith("**")) {
              return (
                <Text key={lineIndex} fontWeight="bold">
                  {line.replace(/\*\*/g, "")}
                </Text>
              );
            }
            if (line.startsWith("Q: ")) {
              return (
                <Text
                  key={lineIndex}
                  fontWeight={600}
                  color="bgColor"
                  fontSize="lg"
                  mt={2}
                >
                  {line}
                </Text>
              );
            }
            if (line.startsWith("A: ")) {
              return (
                <Text key={lineIndex} ml={4}>
                  {line}
                </Text>
              );
            }
            if (line.includes("http")) {
              return (
                <Text key={lineIndex} color="blue.600">
                  <Link href={line.trim()} color="blue.600" isExternal>
                    {line.trim()}
                  </Link>
                </Text>
              );
            }
            if (line.trim() === "") {
              return null;
            }
            return <Text key={lineIndex}>{line}</Text>;
          })}
          {index < faqData?.split("---").length - 1 && <Divider mt={6} />}
        </Box>
      ))}
    </Box>
  );
};

export default GptecFAQ;
